import { StyledButton as StyledButton$1 } from '../../Basic/Button/Button.styles.mjs';
import { StyledHeading } from '../../Typography/Heading/Heading.mjs';
import styled from 'styled-components';

const StyledRegionSelector = styled.section `
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 1rem 2.5rem;
  width: 100%;
  box-sizing: border-box;

  ${StyledButton$1} {
    ${StyledHeading} {
      margin: 0;
    }
  }
`;
const StyledLocation = styled.div `
  display: flex;
  align-items: center;
  user-select: none;
  gap: 0.5rem;

  svg {
    height: 100%;
    width: 14px;
    margin: -1px 1px 0 1px;
  }
`;
const StyledButton = styled(StyledButton$1) `
  padding-top: 0;
  padding-bottom: 3px;
  padding-right: 0;
`;

export { StyledButton, StyledLocation, StyledRegionSelector };
//# sourceMappingURL=RegionSelector.styles.mjs.map
